module.exports = __webpack_public_path__ + "static/media/btn_sphere.d19c5de4.png";